import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';

import {GUKEO_API_URL} from '../../defines/protocol';
import {IsContainHttp} from '../../defines/common.func';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private http: HttpClient,
  ) { }

  Get(api: string, params: any = null, headers: {} | null = null): Observable<any> {
    // Browsable API 에서 형식을 지정해서 받는 방식
    // const urlApi = GUKEO_API_URL + api + '?format=json';
    const urlApi = IsContainHttp(api) ? api : GUKEO_API_URL + api;
    console.log('ApiService.Get() urlApi =', urlApi);

    const options = {
      headers: new HttpHeaders({
        ...(headers || {}),
      }),
      params};
    return this.http.get(urlApi, options);
  }

  Post(api: string, data: any, params: {} | null = null, headers: {} | null = null): Observable<any> {
    const urlApi = IsContainHttp(api) ? api : GUKEO_API_URL + api;

    let options: any = {...params};
    if (headers) {
      const httpHeaders = new HttpHeaders(headers);
      options = {headers: httpHeaders, ...options}
    }

    console.log('ApiService::Post()', urlApi, data, options, headers);

    return this.http.post(urlApi,
      JSON.stringify(data),
      options);
  }

  Delete(api: string, params: {} | null = null, headers: {} | null = null): Observable<any> {
    const urlApi = IsContainHttp(api) ? api : GUKEO_API_URL + api;
    console.log('ApiService.Delete() urlApi =', urlApi);

    let options: any = {params};
    if (headers) {
      const httpHeaders = new HttpHeaders(headers);
      options = {headers: httpHeaders, ...options};
    }
    return this.http.delete(urlApi, options);
  }
}
